import { useState } from "react";
import { NavLink, Outlet, useNavigate, Navigate } from "react-router-dom";
import { useAdmin } from "./AdminContext";
import { Logo } from "@/components/site/Logo";
import {
  LayoutDashboard, ShoppingBag, Layers, DollarSign, Ticket, Users, Star,
  FileText, Settings as SettingsIcon, ScrollText, LogOut, Menu, X, Plug,
} from "lucide-react";

const NAV = [
  { to: "/adc/dashboard", label: "Dashboard", Icon: LayoutDashboard },
  { to: "/adc/orders", label: "Siparişler", Icon: ShoppingBag },
  { to: "/adc/services", label: "Servisler", Icon: Layers },
  { to: "/adc/pricing", label: "Fiyatlandırma", Icon: DollarSign },
  { to: "/adc/coupons", label: "Kuponlar", Icon: Ticket },
  { to: "/adc/customers", label: "Müşteriler", Icon: Users },
  { to: "/adc/reviews", label: "Yorumlar", Icon: Star },
  { to: "/adc/blog", label: "Blog", Icon: FileText },
  { to: "/adc/integrations", label: "Entegrasyonlar", Icon: Plug },
  { to: "/adc/settings", label: "Site & SEO Ayarları", Icon: SettingsIcon },
  { to: "/adc/logs", label: "Loglar", Icon: ScrollText },
];

export default function AdminLayout() {
  const { admin, logout } = useAdmin();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  if (admin === null) return <div className="min-h-screen bg-[#1f222d] flex items-center justify-center text-white">Yükleniyor...</div>;
  if (admin === false) return <Navigate to="/adc" replace />;

  const doLogout = () => { logout(); navigate("/adc"); };

  const SidebarContent = () => (
    <>
      <div className="p-5 border-b border-white/10"><Logo className="h-8" /></div>
      <nav className="flex-1 p-3 space-y-1 overflow-y-auto">
        {NAV.map(({ to, label, Icon }) => (
          <NavLink key={to} to={to} onClick={() => setOpen(false)} data-testid={`adminnav-${to.split("/").pop()}`}
            className={({ isActive }) => `flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm font-medium transition-colors ${isActive ? "bg-white text-[#1f222d]" : "text-gray-400 hover:text-white hover:bg-white/5"}`}>
            <Icon size={18} /> {label}
          </NavLink>
        ))}
      </nav>
      <div className="p-3 border-t border-white/10">
        <button onClick={doLogout} className="flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm font-medium text-gray-400 hover:text-red-400 hover:bg-red-500/10 w-full" data-testid="admin-logout">
          <LogOut size={18} /> Çıkış Yap
        </button>
      </div>
    </>
  );

  return (
    <div className="min-h-screen bg-[#1f222d] flex">
      <aside className="hidden lg:flex flex-col w-64 bg-[#171922] border-r border-white/10 fixed inset-y-0">
        <SidebarContent />
      </aside>
      {open && (
        <div className="lg:hidden fixed inset-0 z-50 flex">
          <div className="absolute inset-0 bg-black/60" onClick={() => setOpen(false)} />
          <aside className="relative flex flex-col w-64 bg-[#171922] border-r border-white/10"><SidebarContent /></aside>
        </div>
      )}
      <div className="flex-1 lg:ml-64">
        <header className="lg:hidden glass border-b border-white/10 h-14 flex items-center justify-between px-4 sticky top-0 z-40">
          <Logo className="h-7" />
          <button onClick={() => setOpen(true)} data-testid="admin-menu-btn"><Menu className="text-white" /></button>
        </header>
        <main className="p-4 sm:p-6 lg:p-8 max-w-7xl mx-auto"><Outlet /></main>
      </div>
    </div>
  );
}
